export const FETCH_DEALER_DETAIL = 'DealerDetail/FETCH_DEALER_DETAIL';
export const RESET_DEALER_DETAIL = 'DealerDetail/RESET_DEALER_DETAIL';
export const UPDATE_PAGE_NUMBER_FILTER = 'DealerDetail/UPDATE_PAGE_NUMBER_FILTER';
export const LIKE_UNLIKE_CAR = 'DealerDetail/LIKE_UNLIKE_CAR';
export const SEARCH_TERM_ADDED = 'DealerDetail/SEARCH_TERM_ADDED';